import { SchoolClassJsonModel } from '../school-class.json.model';

export namespace SchoolClassActions {

  export class Delete {
    static readonly type = getActionName('Delete SchoolClasses');

    constructor(readonly payload: SchoolClassJsonModel) {
    }
  }

  export class Fetch {
    static readonly type = getActionName('Fetch SchoolClasses');
    constructor(
      public overrideOptions?: {
        pageNumber?: number
        pageSize?: number
        skipStoreDispatch?: boolean
      }
    ) {}
  }

  export class FetchAppend {
    static readonly type = getActionName('Fetch SchoolClasses and append');
    constructor(
      public overrideOptions?: {
        pageNumber?: number
        pageSize?: number
        skipStoreDispatch?: boolean
      }
    ) {}
  }

  export class FetchSuccess {
    static readonly type = getActionName('Fetch SchoolClasses success');

    constructor(readonly payload: SchoolClassJsonModel[]) {
    }
  }

  export class FetchSuccessAppend {
    static readonly type = getActionName('Fetch success append SchoolClasses');

    constructor(readonly payload: SchoolClassJsonModel[]) {
    }
  }

  function getActionName(type: string) {
    return `[SchoolClass] ${type}`;
  }

}
